import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = "https://bmtvendorvendorfinal.onrender.com/api/vendor/hotels";

/* Token helper - dono keys check karta hai */
const getToken = () => {
  const t = localStorage.getItem("vendorToken") || localStorage.getItem("token");
  return t && t !== "undefined" && t !== "null" ? t : null;
};
const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

const HOTEL_TYPES     = ["Hotel","Resort","Villa","Hostel","Boutique","Motel","Guesthouse","Apartment"];
const STAR_RATINGS    = [1,2,3,4,5];
const PAYMENT_METHODS = ["Cash","Credit Card","Debit Card","UPI","Net Banking","Wallet","Cheque"];
const AMENITIES_LIST  = ["WiFi","Pool","Gym","Spa","Restaurant","Bar","Room Service","Parking","AC","Elevator","Laundry","Conference Room","Kids Play Area","Library","Terrace"];
const PROP_HIGHLIGHTS = ["Beachfront","Mountain View","City Center","Heritage Building","Eco-Friendly","Family Friendly","Pet Friendly","Adults Only","Countryside"];
const FOOD_DINING     = ["All-Day Dining","Rooftop Restaurant","Cafe","Bar & Lounge","Room Service 24/7","BBQ Area","Poolside Snacks","Fine Dining","Buffet Breakfast"];
const SAFETY_LIST     = ["24/7 Security","CCTV","Fire Safety","Safe Deposit Box","Security Guard","Smoke Detector","Emergency Exit","First Aid"];
const WELLNESS_LIST   = ["Spa","Yoga Center","Meditation Room","Steam Room","Sauna","Jacuzzi","Massage","Aromatherapy","Infinity Pool"];
const BUSINESS_LIST   = ["Conference Hall","Business Center","Meeting Rooms","Projector","High-Speed Internet","Fax/Printing","Co-Working Space"];
const MEDIA_LIST      = ["Smart TV","Netflix","Cable TV","Music System","Gaming Console","Streaming Services","Sound System"];
const TRANSPORT_LIST  = ["Airport Pickup","Car Rental","Taxi Service","Shuttle Bus","Valet Parking","Bicycle Rental","Boat Service"];

const ARR_KEYS = ["amenities","propertyHighlights","foodAndDining","safetyAndSecurity",
  "wellnessAndSpa","businessFacilities","mediaAndTechnology","transportServices","paymentMethods"];

const emptyHotel = {
  hotelName:"", hotelType:"", description:"", starRating:"", yearBuilt:"",
  phone:"", alternatePhone:"", email:"", website:"",
  country:"India", state:"", city:"", area:"", address:"", pincode:"", landmark:"",
  latitude:"", longitude:"",
  amenities:[], propertyHighlights:[], foodAndDining:[], safetyAndSecurity:[],
  wellnessAndSpa:[], businessFacilities:[], mediaAndTechnology:[], transportServices:[],
  paymentMethods:[],
  checkInTime:"", checkOutTime:"",
  earlyCheckInAllowed:false, lateCheckOutAllowed:false,
  cancellationPolicy:"", childPolicy:"", petPolicy:"",
  coupleFriendly:true, localIdAllowed:true,
  pricePerNight:"", taxPercentage:"", serviceCharge:"", extraBedCharge:"",
  refundPolicy:"", gstNumber:"", virtualTourLink:"",
};

const TABS = [
  ["basic","🏨 Basic Details"],["location","📍 Location"],["facilities","✨ Facilities"],
  ["policies","📋 Policies"],["pricing","💰 Pricing"],["media","📸 Media"],
];

export default function VendorHotels() {
  const [hotels, setHotels]       = useState([]);
  const [filtered, setFiltered]   = useState([]);
  const [loading, setLoading]     = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError]         = useState("");

  const [view, setView]           = useState("list"); // "list" | "form"
  const [editHotelId, setEditHotelId] = useState(null);
  const [tab, setTab]             = useState("basic");
  const [hf, setHf]               = useState({ ...emptyHotel });
  const [hImgs, setHImgs]         = useState([]);   // new File objects
  const [hImgPrev, setHImgPrev]   = useState([]);   // previews of new files
  const [hExisting, setHExisting] = useState([]);   // urls already on server

  const [showF, setShowF] = useState(false);
  const [filt, setFilt]   = useState({ q:"", city:"", hotelType:"", sort:"newest" });

  useEffect(() => {
    if (!getToken()) { window.location.replace("/vendor-login"); return; }
    load();
    // eslint-disable-next-line
  }, []);
  useEffect(() => { applyFilters(); /* eslint-disable-next-line */ }, [hotels, filt]);

  /* ===== LOAD ===== */
  const load = async () => {
    try {
      setLoading(true); setError("");
      const r = await axios.get(API_URL, { headers: authHeaders() });
      const d = r.data;
      setHotels(
        Array.isArray(d) ? d
        : Array.isArray(d?.hotels) ? d.hotels
        : Array.isArray(d?.data) ? d.data
        : Array.isArray(d?.data?.hotels) ? d.data.hotels : []
      );
    } catch (e) {
      setHotels([]);
      setError(e.response?.data?.message || "Failed to load hotels");
    } finally { setLoading(false); }
  };

  /* ===== FILTERS ===== */
  const applyFilters = () => {
    let r = [...hotels];
    if (filt.q) {
      const q = filt.q.toLowerCase();
      r = r.filter(h => (h.hotelName||"").toLowerCase().includes(q) || (h.city||"").toLowerCase().includes(q));
    }
    if (filt.city)      r = r.filter(h => (h.city||"").toLowerCase().includes(filt.city.toLowerCase()));
    if (filt.hotelType) r = r.filter(h => h.hotelType === filt.hotelType);
    if (filt.sort==="rating") r.sort((a,b)=>(b.starRating||0)-(a.starRating||0));
    else if (filt.sort==="name") r.sort((a,b)=>(a.hotelName||"").localeCompare(b.hotelName||""));
    else r.sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt));
    setFiltered(r);
  };

  const setH = (k, v) => setHf(p => ({ ...p, [k]: v }));
  const chipToggle = (key, val) => setHf(p => ({
    ...p, [key]: p[key].includes(val) ? p[key].filter(x=>x!==val) : [...p[key], val],
  }));

  /* ===== IMAGES ===== */
  const totalImgs = hExisting.length + hImgs.length;

  const addHotelImgs = (e) => {
    const files = [...e.target.files].filter(f => f.type.startsWith("image/") && f.size <= 5*1024*1024);
    if (totalImgs + files.length > 10) { setError("Maximum 10 images allowed"); e.target.value=""; return; }
    setHImgs(p => [...p, ...files]);
    setHImgPrev(p => [...p, ...files.map(f => URL.createObjectURL(f))]);
    e.target.value = "";
  };
  const removeNewImg = (i) => {
    setHImgs(p => p.filter((_,x)=>x!==i));
    setHImgPrev(p => p.filter((_,x)=>x!==i));
  };
  const removeExistingImg = async (url) => {
    if (!window.confirm("Ye image delete karni hai?")) return;
    try {
      await axios.delete(`${API_URL}/${editHotelId}/images`, { headers: authHeaders(), data: { imageUrl: url } });
      setHExisting(p => p.filter(u => u !== url));
      load();
    } catch (e) { setError(e.response?.data?.message || "Image delete failed"); }
  };

  /* ===== OPEN / CLOSE FORM ===== */
  const openAdd = () => {
    setEditHotelId(null); setHf({ ...emptyHotel });
    setHImgs([]); setHImgPrev([]); setHExisting([]);
    setTab("basic"); setError(""); setView("form");
    window.scrollTo(0, 0);
  };

  const openEdit = (h) => {
    const n = (v) => (v != null ? String(v) : "");
    setEditHotelId(h._id);
    setHf({
      ...emptyHotel,
      hotelName:h.hotelName||"", hotelType:h.hotelType||"", description:h.description||"",
      starRating:n(h.starRating), yearBuilt:n(h.yearBuilt),
      phone:h.phone||"", alternatePhone:h.alternatePhone||"", email:h.email||"", website:h.website||"",
      country:h.country||"India", state:h.state||"", city:h.city||"", area:h.area||"",
      address:h.address||"", pincode:h.pincode||"", landmark:h.landmark||"",
      latitude:n(h.location?.coordinates?.[1]), longitude:n(h.location?.coordinates?.[0]),
      amenities:h.amenities||[], propertyHighlights:h.propertyHighlights||[],
      foodAndDining:h.foodAndDining||[], safetyAndSecurity:h.safetyAndSecurity||[],
      wellnessAndSpa:h.wellnessAndSpa||[], businessFacilities:h.businessFacilities||[],
      mediaAndTechnology:h.mediaAndTechnology||[], transportServices:h.transportServices||[],
      paymentMethods:h.paymentMethods||[],
      checkInTime:h.checkInTime||"", checkOutTime:h.checkOutTime||"",
      earlyCheckInAllowed:h.earlyCheckInAllowed ?? false, lateCheckOutAllowed:h.lateCheckOutAllowed ?? false,
      cancellationPolicy:h.cancellationPolicy||"", childPolicy:h.childPolicy||"", petPolicy:h.petPolicy||"",
      coupleFriendly:h.coupleFriendly ?? true, localIdAllowed:h.localIdAllowed ?? true,
      pricePerNight:n(h.pricePerNight), taxPercentage:n(h.taxPercentage),
      serviceCharge:n(h.serviceCharge), extraBedCharge:n(h.extraBedCharge),
      refundPolicy:h.refundPolicy||"", gstNumber:h.gstNumber||"", virtualTourLink:h.virtualTourLink||"",
    });
    setHImgs([]); setHImgPrev([]); setHExisting(h.hotelImages || []);
    setTab("basic"); setError(""); setView("form");
    window.scrollTo(0, 0);
  };

  const closeForm = () => {
    setView("list"); setEditHotelId(null); setHf({ ...emptyHotel });
    setHImgs([]); setHImgPrev([]); setHExisting([]); setTab("basic"); setError("");
  };

  /* ===== SUBMIT ===== */
  const submitHotel = async (e) => {
    e.preventDefault();
    if (!hf.hotelName.trim()) { setTab("basic");    setError("Hotel name zaruri hai"); window.scrollTo(0,0); return; }
    if (!hf.city.trim())      { setTab("location"); setError("City zaruri hai"); window.scrollTo(0,0); return; }
    if (hExisting.length + hImgs.length === 0) {
      setTab("media"); setError("Kam se kam 1 hotel image upload karo"); window.scrollTo(0,0); return;
    }

    setSubmitting(true); setError("");
    const fd = new FormData();
    Object.entries(hf).forEach(([k, v]) => {
      if (ARR_KEYS.includes(k)) fd.append(k, JSON.stringify(v));
      else if (typeof v === "boolean") fd.append(k, String(v));
      else if (v !== "" && v !== null && v !== undefined) fd.append(k, v);
    });
    hImgs.forEach(img => fd.append("hotelImages", img));

    try {
      if (editHotelId) await axios.put(`${API_URL}/${editHotelId}`, fd, { headers: authHeaders() });
      else             await axios.post(API_URL, fd, { headers: authHeaders() });
      closeForm();
      load();
    } catch (err) {
      setError(err.response?.data?.message || "Save failed");
      window.scrollTo(0, 0);
    } finally { setSubmitting(false); }
  };

  /* ===== DELETE ===== */
  const delHotel = async (id) => {
    if (!window.confirm("Hotel delete karna chahte ho?")) return;
    try {
      await axios.delete(`${API_URL}/${id}`, { headers: authHeaders() });
      load();
    } catch { setError("Delete failed"); }
  };

  /* ================= RENDER ================= */
  return (
    <div style={s.page}>

      {/* HEADER */}
      <div style={s.hdr}>
        <div>
          <h1 style={s.h1}>
            🏨 {view === "form" ? (editHotelId ? "Edit Hotel" : "Add New Hotel") : "Manage Hotels"}
          </h1>
          <p style={s.sub}>{view === "form" ? "Sab details bharke Save karo" : `${filtered.length} hotel(s)`}</p>
        </div>
        <div style={{display:"flex",gap:12}}>
          {view === "form" ? (
            <Btn gray onClick={closeForm}>← Back to Hotels</Btn>
          ) : (
            <>
              <Btn gray onClick={()=>setShowF(p=>!p)}>🔍 Filters</Btn>
              <Btn blue onClick={openAdd} disabled={loading}>➕ Add Hotel</Btn>
            </>
          )}
        </div>
      </div>

      {error && (
        <div style={s.err}>
          <span>⚠️ {error}</span>
          <button onClick={()=>setError("")} style={{background:"none",border:"none",color:"#991b1b",fontSize:18,cursor:"pointer"}}>✕</button>
        </div>
      )}

      {/* ============ LIST VIEW ============ */}
      {view === "list" && (
        <>
          {showF && (
            <div style={s.filterBox}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:16,marginBottom:14}}>
                <FI label="Search" placeholder="Name ya city…" value={filt.q} onChange={e=>setFilt(p=>({...p,q:e.target.value}))} />
                <FI label="City" placeholder="e.g. Mumbai" value={filt.city} onChange={e=>setFilt(p=>({...p,city:e.target.value}))} />
                <FS label="Hotel Type" value={filt.hotelType} onChange={e=>setFilt(p=>({...p,hotelType:e.target.value}))} options={HOTEL_TYPES} placeholder="All Types" />
                <FS label="Sort By" value={filt.sort} onChange={e=>setFilt(p=>({...p,sort:e.target.value}))}
                  options={[{v:"newest",l:"Newest"},{v:"rating",l:"Best Rated"},{v:"name",l:"Name A-Z"}]} />
              </div>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{fontSize:13,color:"#64748b"}}>Showing {filtered.length} of {hotels.length}</span>
                <Btn gray onClick={()=>setFilt({q:"",city:"",hotelType:"",sort:"newest"})}>Reset</Btn>
              </div>
            </div>
          )}

          {loading && <div style={s.loader}>Loading…</div>}

          {!loading && filtered.length === 0 && (
            <div style={s.empty}>
              <div style={{fontSize:64}}>🏨</div>
              <p style={{color:"#9ca3af"}}>{hotels.length===0 ? '"Add Hotel" click karo' : "Filters adjust karo"}</p>
            </div>
          )}

          {!loading && filtered.length > 0 && (
            <div style={s.tblWrap}>
              <table style={s.tbl}>
                <thead>
                  <tr style={{backgroundColor:"#f8fafc"}}>
                    {["Image","Hotel Info","Location","Type / Stars","Pricing","Status","Actions"].map(h=>(
                      <th key={h} style={s.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(h=>(
                    <tr key={h._id} style={s.tr}>
                      <td style={s.td}>
                        {h.hotelImages?.[0] ? <img src={h.hotelImages[0]} alt="" style={s.thumb}/> : <div style={s.noThumb}>🏨</div>}
                        {h.hotelImages?.length>1 && <div style={{fontSize:10,color:"#9ca3af",textAlign:"center",marginTop:3}}>+{h.hotelImages.length-1}</div>}
                      </td>
                      <td style={s.td}>
                        <div style={{fontWeight:700,fontSize:14,color:"#111"}}>{h.hotelName}</div>
                        {h.description && <div style={{fontSize:12,color:"#6b7280",maxWidth:190}}>{h.description.slice(0,65)}{h.description.length>65?"…":""}</div>}
                        {h.phone && <div style={{fontSize:11,color:"#9ca3af",marginTop:2}}>📞 {h.phone}</div>}
                        {h.email && <div style={{fontSize:11,color:"#9ca3af"}}>✉️ {h.email}</div>}
                        {h.gstNumber && <div style={{fontSize:11,color:"#9ca3af"}}>GST: {h.gstNumber}</div>}
                      </td>
                      <td style={s.td}>
                        <div style={{fontSize:13}}>📍 {[h.city,h.state].filter(Boolean).join(", ")}</div>
                        {h.address && <div style={{fontSize:11,color:"#9ca3af",marginTop:2}}>{h.address.slice(0,45)}</div>}
                        {h.landmark && <div style={{fontSize:11,color:"#9ca3af"}}>Near: {h.landmark}</div>}
                      </td>
                      <td style={s.td}>
                        {h.hotelType && <span style={s.badge}>{h.hotelType}</span>}
                        <div style={{marginTop:5,fontSize:15}}>{"⭐".repeat(h.starRating||0)||"—"}</div>
                        {h.yearBuilt && <div style={{fontSize:11,color:"#9ca3af"}}>Est. {h.yearBuilt}</div>}
                      </td>
                      <td style={s.td}>
                        {h.pricePerNight != null && <div style={{fontWeight:700,color:"#2563eb",fontSize:15}}>₹{h.pricePerNight}<span style={{fontWeight:400,fontSize:11,color:"#9ca3af"}}>/night</span></div>}
                        {h.taxPercentage != null && <div style={{fontSize:11,color:"#6b7280"}}>Tax: {h.taxPercentage}%</div>}
                        {h.serviceCharge != null && <div style={{fontSize:11,color:"#6b7280"}}>Svc: ₹{h.serviceCharge}</div>}
                      </td>
                      <td style={s.td}>
                        <span style={{...s.pill,...(h.status==="approved"?s.green:h.status==="rejected"?s.red:s.yellow)}}>{h.status}</span>
                        {h.featured && <span style={{...s.pill,...s.blue,marginTop:4,display:"block"}}>⭐ Featured</span>}
                        {h.isActive === false && <span style={{...s.pill,...s.red,marginTop:4,display:"block"}}>Inactive</span>}
                      </td>
                      <td style={s.td}>
                        <div style={{display:"flex",gap:8}}>
                          <button style={s.eBtn} onClick={()=>openEdit(h)}>✏️</button>
                          <button style={s.dBtn} onClick={()=>delHotel(h._id)}>🗑️</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* ============ FORM VIEW (FULL PAGE) ============ */}
      {view === "form" && (
        <>
          {/* TOP SECTION BAR: Basic Details first */}
          <div style={s.tabBar}>
            {TABS.map(([k,l])=>(
              <button key={k} type="button"
                style={{...s.tabBtn,...(tab===k?s.tabOn:{})}}
                onClick={()=>setTab(k)}>{l}</button>
            ))}
          </div>

          <form onSubmit={submitHotel} style={s.formCard}>

            {tab==="basic" && (
              <div style={s.g2}>
                <div style={{gridColumn:"1/-1"}}>
                  <Label>Hotel Name *</Label>
                  <input value={hf.hotelName} onChange={e=>setH("hotelName",e.target.value)} placeholder="e.g. Grand Palace Hotel" style={s.inp}/>
                </div>
                <div>
                  <Label>Hotel Type</Label>
                  <select value={hf.hotelType} onChange={e=>setH("hotelType",e.target.value)} style={s.sel}>
                    <option value="">Select Type</option>
                    {HOTEL_TYPES.map(t=><option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <Label>Star Rating</Label>
                  <select value={hf.starRating} onChange={e=>setH("starRating",e.target.value)} style={s.sel}>
                    <option value="">Select Stars</option>
                    {STAR_RATINGS.map(r=><option key={r} value={r}>{"⭐".repeat(r)} ({r} Star)</option>)}
                  </select>
                </div>
                <div>
                  <Label>Year Built</Label>
                  <input type="number" value={hf.yearBuilt} onChange={e=>setH("yearBuilt",e.target.value)} placeholder="e.g. 2010" style={s.inp}/>
                </div>
                <div>
                  <Label>GST Number</Label>
                  <input value={hf.gstNumber} onChange={e=>setH("gstNumber",e.target.value)} placeholder="22AAAAA0000A1Z5" style={s.inp}/>
                </div>
                <div style={{gridColumn:"1/-1"}}>
                  <Label>Description</Label>
                  <textarea value={hf.description} onChange={e=>setH("description",e.target.value)} placeholder="Hotel ke baare mein likhein…" rows={4} style={{...s.inp,resize:"vertical"}}/>
                </div>
                <div>
                  <Label>Phone</Label>
                  <input value={hf.phone} onChange={e=>setH("phone",e.target.value)} placeholder="+91 98765 43210" style={s.inp}/>
                </div>
                <div>
                  <Label>Alternate Phone</Label>
                  <input value={hf.alternatePhone} onChange={e=>setH("alternatePhone",e.target.value)} placeholder="+91 98765 43211" style={s.inp}/>
                </div>
                <div>
                  <Label>Email</Label>
                  <input type="email" value={hf.email} onChange={e=>setH("email",e.target.value)} placeholder="hotel@example.com" style={s.inp}/>
                </div>
                <div>
                  <Label>Website</Label>
                  <input value={hf.website} onChange={e=>setH("website",e.target.value)} placeholder="https://yourhotel.com" style={s.inp}/>
                </div>
              </div>
            )}

            {tab==="location" && (
              <div style={s.g2}>
                <div><Label>Country</Label><input value={hf.country} onChange={e=>setH("country",e.target.value)} style={s.inp}/></div>
                <div><Label>State</Label><input value={hf.state} onChange={e=>setH("state",e.target.value)} placeholder="Punjab" style={s.inp}/></div>
                <div><Label>City *</Label><input value={hf.city} onChange={e=>setH("city",e.target.value)} placeholder="Ludhiana" style={s.inp}/></div>
                <div><Label>Area / Locality</Label><input value={hf.area} onChange={e=>setH("area",e.target.value)} style={s.inp}/></div>
                <div><Label>Pincode</Label><input value={hf.pincode} onChange={e=>setH("pincode",e.target.value)} style={s.inp}/></div>
                <div><Label>Landmark</Label><input value={hf.landmark} onChange={e=>setH("landmark",e.target.value)} style={s.inp}/></div>
                <div style={{gridColumn:"1/-1"}}>
                  <Label>Full Address</Label>
                  <textarea value={hf.address} onChange={e=>setH("address",e.target.value)} rows={2} style={{...s.inp,resize:"vertical"}}/>
                </div>
                <div><Label>Latitude</Label><input type="number" step="any" value={hf.latitude} onChange={e=>setH("latitude",e.target.value)} style={s.inp}/></div>
                <div><Label>Longitude</Label><input type="number" step="any" value={hf.longitude} onChange={e=>setH("longitude",e.target.value)} style={s.inp}/></div>
              </div>
            )}

            {tab==="facilities" && (
              <div style={{display:"flex",flexDirection:"column",gap:20}}>
                {[
                  ["Amenities", AMENITIES_LIST, "amenities"],
                  ["Property Highlights", PROP_HIGHLIGHTS, "propertyHighlights"],
                  ["Food & Dining", FOOD_DINING, "foodAndDining"],
                  ["Safety & Security", SAFETY_LIST, "safetyAndSecurity"],
                  ["Wellness & Spa", WELLNESS_LIST, "wellnessAndSpa"],
                  ["Business Facilities", BUSINESS_LIST, "businessFacilities"],
                  ["Media & Technology", MEDIA_LIST, "mediaAndTechnology"],
                  ["Transport Services", TRANSPORT_LIST, "transportServices"],
                  ["Payment Methods", PAYMENT_METHODS, "paymentMethods"],
                ].map(([lbl, opts, key])=>(
                  <div key={key}>
                    <Label>{lbl}</Label>
                    <div style={{display:"flex",flexWrap:"wrap",gap:8,marginTop:6}}>
                      {opts.map(o=>(
                        <button key={o} type="button" onClick={()=>chipToggle(key,o)}
                          style={{...s.chip,...(hf[key].includes(o)?s.chipOn:{})}}>{o}</button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {tab==="policies" && (
              <div style={s.g2}>
                <div><Label>Check-In Time</Label><input type="time" value={hf.checkInTime} onChange={e=>setH("checkInTime",e.target.value)} style={s.inp}/></div>
                <div><Label>Check-Out Time</Label><input type="time" value={hf.checkOutTime} onChange={e=>setH("checkOutTime",e.target.value)} style={s.inp}/></div>
                <div style={{gridColumn:"1/-1",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:12}}>
                  <CbRow label="Early Check-In" checked={hf.earlyCheckInAllowed} onChange={v=>setH("earlyCheckInAllowed",v)}/>
                  <CbRow label="Late Check-Out" checked={hf.lateCheckOutAllowed} onChange={v=>setH("lateCheckOutAllowed",v)}/>
                  <CbRow label="Couple Friendly" checked={hf.coupleFriendly} onChange={v=>setH("coupleFriendly",v)}/>
                  <CbRow label="Local ID Allowed" checked={hf.localIdAllowed} onChange={v=>setH("localIdAllowed",v)}/>
                </div>
                <div style={{gridColumn:"1/-1"}}>
                  <Label>Cancellation Policy</Label>
                  <textarea value={hf.cancellationPolicy} onChange={e=>setH("cancellationPolicy",e.target.value)} rows={3} style={{...s.inp,resize:"vertical"}}/>
                </div>
                <div>
                  <Label>Child Policy</Label>
                  <textarea value={hf.childPolicy} onChange={e=>setH("childPolicy",e.target.value)} rows={3} style={{...s.inp,resize:"vertical"}}/>
                </div>
                <div>
                  <Label>Pet Policy</Label>
                  <textarea value={hf.petPolicy} onChange={e=>setH("petPolicy",e.target.value)} rows={3} style={{...s.inp,resize:"vertical"}}/>
                </div>
                <div style={{gridColumn:"1/-1"}}>
                  <Label>Refund Policy</Label>
                  <textarea value={hf.refundPolicy} onChange={e=>setH("refundPolicy",e.target.value)} rows={3} style={{...s.inp,resize:"vertical"}}/>
                </div>
              </div>
            )}

            {tab==="pricing" && (
              <div style={s.g2}>
                <div><Label>Starting Price / Night (₹)</Label><input type="number" value={hf.pricePerNight} onChange={e=>setH("pricePerNight",e.target.value)} placeholder="2500" style={s.inp}/></div>
                <div><Label>Tax (%)</Label><input type="number" value={hf.taxPercentage} onChange={e=>setH("taxPercentage",e.target.value)} placeholder="18" style={s.inp}/></div>
                <div><Label>Service Charge (₹)</Label><input type="number" value={hf.serviceCharge} onChange={e=>setH("serviceCharge",e.target.value)} placeholder="200" style={s.inp}/></div>
                <div><Label>Extra Bed Charge (₹)</Label><input type="number" value={hf.extraBedCharge} onChange={e=>setH("extraBedCharge",e.target.value)} placeholder="500" style={s.inp}/></div>
              </div>
            )}

            {tab==="media" && (
              <div style={{display:"flex",flexDirection:"column",gap:20}}>
                <div>
                  <Label>Hotel Images (Max 10) <span style={{color:"#e11d48"}}>*</span></Label>
                  <div style={s.gallery}>
                    {hExisting.map(src=>(
                      <div key={src} style={s.gItem}>
                        <img src={src} alt="" style={s.gImg}/>
                        <button type="button" style={s.gX} onClick={()=>removeExistingImg(src)}>✕</button>
                      </div>
                    ))}
                    {hImgPrev.map((src,i)=>(
                      <div key={src} style={s.gItem}>
                        <img src={src} alt="" style={{...s.gImg,borderColor:"#2563eb"}}/>
                        <button type="button" style={s.gX} onClick={()=>removeNewImg(i)}>✕</button>
                      </div>
                    ))}
                    {totalImgs < 10 && (
                      <label style={s.gAdd}>➕ Add
                        <input type="file" multiple accept="image/*" hidden onChange={addHotelImgs}/>
                      </label>
                    )}
                  </div>
                  <p style={{fontSize:12,color:"#9ca3af",marginTop:6}}>Max 10 • Max 5MB each • JPG/PNG/WEBP</p>
                </div>
                <div>
                  <Label>Virtual Tour Link</Label>
                  <input value={hf.virtualTourLink} onChange={e=>setH("virtualTourLink",e.target.value)} placeholder="https://my360tour.com/hotel" style={s.inp}/>
                </div>
              </div>
            )}

            <div style={s.mFoot}>
              <button type="button" style={s.btnG} onClick={closeForm} disabled={submitting}>Cancel</button>
              <button type="submit" style={s.btnB} disabled={submitting}>
                {submitting ? "⏳ Saving…" : editHotelId ? "💾 Update Hotel" : "➕ Add Hotel"}
              </button>
            </div>
          </form>
        </>
      )}
    </div>
  );
}

/* ===== helper components ===== */
const Label = ({children}) => <label style={{display:"block",fontSize:13,fontWeight:700,color:"#374151",marginBottom:5}}>{children}</label>;
const Btn = ({children,blue,onClick,disabled}) => (
  <button type="button" onClick={onClick} disabled={disabled}
    style={{padding:"11px 22px",fontSize:14,fontWeight:700,border:"none",borderRadius:8,cursor:"pointer",
      color: blue?"#fff":"#374151", backgroundColor: blue?"#2563eb":"#e5e7eb"}}>{children}</button>
);
const CbRow = ({label,checked,onChange}) => (
  <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:14,fontWeight:500,color:"#374151",userSelect:"none"}}>
    <input type="checkbox" checked={checked} onChange={e=>onChange(e.target.checked)} style={{width:16,height:16,cursor:"pointer"}}/>
    <span>{label}</span>
  </label>
);
const FI = ({label,placeholder,value,onChange}) => (
  <div><label style={{display:"block",fontSize:13,fontWeight:600,color:"#374151",marginBottom:5}}>{label}</label>
    <input placeholder={placeholder} value={value} onChange={onChange} style={s.inp}/></div>
);
const FS = ({label,value,onChange,options,placeholder}) => (
  <div><label style={{display:"block",fontSize:13,fontWeight:600,color:"#374151",marginBottom:5}}>{label}</label>
    <select value={value} onChange={onChange} style={s.sel}>
      {placeholder && <option value="">{placeholder}</option>}
      {options.map(o=>typeof o==="object" ? <option key={o.v} value={o.v}>{o.l}</option> : <option key={o} value={o}>{o}</option>)}
    </select></div>
);

/* ===== styles ===== */
const s = {
  page:{maxWidth:1400,margin:"0 auto",padding:"32px 24px",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",backgroundColor:"#f1f5f9",minHeight:"100vh"},
  hdr:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24,flexWrap:"wrap",gap:16},
  h1:{fontSize:28,fontWeight:800,color:"#0f172a",margin:0},
  sub:{fontSize:14,color:"#64748b",margin:"4px 0 0"},
  err:{marginBottom:20,padding:"12px 16px",background:"#fee2e2",border:"1px solid #fca5a5",borderRadius:8,color:"#991b1b",display:"flex",justifyContent:"space-between",alignItems:"center"},
  filterBox:{background:"#fff",borderRadius:12,padding:20,marginBottom:20,boxShadow:"0 1px 4px rgba(0,0,0,0.06)"},
  loader:{textAlign:"center",padding:64,fontSize:18,color:"#64748b"},
  empty:{textAlign:"center",padding:"80px 24px",backgroundColor:"#fff",borderRadius:12,boxShadow:"0 1px 4px rgba(0,0,0,0.06)"},
  tblWrap:{background:"#fff",borderRadius:12,boxShadow:"0 1px 4px rgba(0,0,0,0.06)",overflowX:"auto"},
  tbl:{width:"100%",borderCollapse:"collapse"},
  th:{padding:"14px 16px",textAlign:"left",fontSize:11,fontWeight:800,color:"#64748b",textTransform:"uppercase",letterSpacing:"0.6px",borderBottom:"2px solid #e2e8f0"},
  tr:{borderBottom:"1px solid #f1f5f9"},
  td:{padding:"14px 16px",fontSize:14,color:"#334155",verticalAlign:"middle"},
  thumb:{width:90,height:68,objectFit:"cover",borderRadius:8,display:"block"},
  noThumb:{width:90,height:68,display:"flex",alignItems:"center",justifyContent:"center",background:"#f1f5f9",borderRadius:8,fontSize:30},
  badge:{display:"inline-block",fontSize:12,fontWeight:700,color:"#1d4ed8",background:"#dbeafe",padding:"3px 10px",borderRadius:12},
  pill:{display:"inline-block",fontSize:11,fontWeight:700,padding:"3px 9px",borderRadius:10},
  green:{background:"#dcfce7",color:"#166534"},
  red:{background:"#fee2e2",color:"#991b1b"},
  yellow:{background:"#fef9c3",color:"#854d0e"},
  blue:{background:"#dbeafe",color:"#1e40af"},
  eBtn:{padding:"7px 11px",fontSize:16,background:"#eff6ff",border:"none",borderRadius:6,cursor:"pointer"},
  dBtn:{padding:"7px 11px",fontSize:16,background:"#fee2e2",border:"none",borderRadius:6,cursor:"pointer"},
  tabBar:{display:"flex",gap:4,padding:"0 12px",background:"#fff",borderRadius:"12px 12px 0 0",borderBottom:"1px solid #e2e8f0",overflowX:"auto"},
  tabBtn:{padding:"15px 20px",fontSize:14,fontWeight:700,color:"#64748b",background:"none",border:"none",borderBottom:"3px solid transparent",cursor:"pointer",whiteSpace:"nowrap"},
  tabOn:{color:"#2563eb",borderBottomColor:"#2563eb"},
  formCard:{background:"#fff",borderRadius:"0 0 12px 12px",padding:28,boxShadow:"0 1px 4px rgba(0,0,0,0.06)"},
  mFoot:{display:"flex",justifyContent:"flex-end",gap:12,paddingTop:20,borderTop:"1px solid #e2e8f0",marginTop:28},
  g2:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:16},
  inp:{width:"100%",padding:"10px 14px",fontSize:14,border:"1.5px solid #d1d5db",borderRadius:8,outline:"none",fontFamily:"inherit",background:"#fff",color:"#111",boxSizing:"border-box"},
  sel:{width:"100%",padding:"10px 14px",fontSize:14,border:"1.5px solid #d1d5db",borderRadius:8,outline:"none",fontFamily:"inherit",background:"#fff",cursor:"pointer",color:"#111",boxSizing:"border-box"},
  chip:{padding:"7px 14px",background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:20,fontSize:13,fontWeight:600,cursor:"pointer",fontFamily:"inherit",color:"#475569"},
  chipOn:{background:"#2563eb",color:"#fff",borderColor:"#2563eb"},
  btnB:{padding:"11px 26px",fontSize:14,fontWeight:700,color:"#fff",backgroundColor:"#2563eb",border:"none",borderRadius:8,cursor:"pointer"},
  btnG:{padding:"11px 22px",fontSize:14,fontWeight:700,color:"#374151",backgroundColor:"#e5e7eb",border:"none",borderRadius:8,cursor:"pointer"},
  gallery:{display:"grid",gridTemplateColumns:"repeat(auto-fill,110px)",gap:12},
  gItem:{position:"relative",width:110,height:84},
  gImg:{width:"100%",height:"100%",objectFit:"cover",borderRadius:8,border:"1.5px solid #e2e8f0"},
  gX:{position:"absolute",top:-7,right:-7,background:"#dc2626",color:"#fff",border:"none",borderRadius:"50%",width:22,height:22,cursor:"pointer",fontSize:12},
  gAdd:{width:110,height:84,border:"2px dashed #cbd5e1",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:"#94a3b8",cursor:"pointer"},
};